var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagingIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.447222 1.14323C0.826389 1.36198 6.08611 4.38976 6.28056 4.50087C6.475 4.61198 6.73102 4.66753 6.9838 4.66753C7.23657 4.66753 7.49259 4.61545 7.68704 4.50087C7.88148 4.38628 13.1444 1.36198 13.5236 1.14323C13.9028 0.924479 14.2625 0.0703125 13.5657 0.0703125H0.405093C-0.291667 0.0703125 0.0680556 0.924479 0.447222 1.14323ZM13.6986 2.98003C13.2676 3.21962 7.95278 6.18837 7.69028 6.3342C7.42778 6.48004 7.23981 6.50087 6.98704 6.50087C6.73426 6.50087 6.5463 6.48351 6.2838 6.3342C6.0213 6.1849 0.732407 3.21615 0.301389 2.97656C0 2.80642 0 3.00781 0 3.16059V9.23698C0 9.58767 0.440741 10.0703 0.777778 10.0703H13.2222C13.5593 10.0703 14 9.58767 14 9.23698V3.16059C14 3.00781 14 2.80642 13.6986 2.97656V2.98003Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingIconTable);
export default __webpack_public_path__ + "static/media/messagingIconTable.f4ac33a4a6e08042cb09b099f89ffce1.svg";
export { ForwardRef as ReactComponent };